import styled from 'styled-components';

export const AuthenticationContainer = styled.div`
  width: 100%;
  display: block;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 30px auto;

  ._bb {
    display: inline-block;
    padding-left: 50px;
    padding-right: 50px;
    padding-bottom: 50px

  }
  ._bc {
    display: inline-block;
    padding-left: 320px;
    padding-right: 50px;
    padding-bottom: 50px

  }
`;
